<template>
  <div class="aaaaa">
  <div class="children-box bbbbb">
    <div class="nav">
      <h3>新增秒杀</h3>
    </div>
    <div class="procedure">
      <el-form :model="formData" label-width="110px">
        <el-form-item label="秒杀时间">
          <template slot="label">
            <span><span style="color: red">*</span>活动时间：</span>
          </template>
          <el-date-picker
            v-model="rangeTime"
            type="datetimerange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss" :default-time="['', '23:59:59']"
            @change="changeTime"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="添加商品" v-if="!seckillProductCode">
          <template slot="label">
            <el-button
              type="primary"
              style="font-size: 16px"
              @click="selectGoodDia"
              >添加商品</el-button
            >
          </template>
        </el-form-item>

        <el-form-item label="属性" label-width="90%">
          <template slot="label">
            <el-table
              border
              ref="table"
              :data="formData.productList"
              tooltip-effect="dark"
              max-height="350px"
              :reserve-selection="true"
              empty-text="暂无数据"
            >
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-table
                    border
                    ref="childTbale"
                    :data="props.row.productSkuList"
                    tooltip-effect="dark"
                    style="width: 100%"
                  >
                    <el-table-column
                      label="序号"
                      type="index"
                      width="50"
                      align="center"
                    ></el-table-column>

                    <el-table-column
                      label="规格"
                      align="center"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">{{
                        scope.row.skuName
                      }}</template>
                    </el-table-column>

                    <el-table-column
                      label="单价(元)"
                      align="center"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">{{
                        scope.row.sellPrice
                      }}</template>
                    </el-table-column>

                    <el-table-column
                      label="秒杀价(元)"
                      align="center"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.seckillPrice"
                          placeholder="请输入"
                          type="number"
                          :style="{ width: '80%' }"
                          @input="handleSonInput($event, scope.$index, props.$index, 1)"
                        ></el-input>
                      </template>
                    </el-table-column>

                    <el-table-column
                      label="秒杀库存"
                      align="center"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.surplusStock"
                          placeholder="请输入"
                          type="number"
                          :style="{ width: '80%' }"
                          @input="handleSonInput($event, scope.$index, props.$index, 2)"
                        ></el-input>
                      </template>
                    </el-table-column>

                    <el-table-column
                      label="参考库存"
                      align="center"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">{{
                        scope.row.stock
                      }}</template>
                    </el-table-column>

                    <el-table-column
                      label="操作"
                      width="290"
                      align="center"
                      v-if="!seckillProductCode"
                    >
                      <template slot-scope="scope">
                        <el-button
                          type="primary"
                          plain
                          @click="handleDeleteSku(scope.$index, props.$index)"
                          >删除</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </el-table-column>
              <el-table-column
                label="序号"
                type="index"
                width="50"
                align="center"
              ></el-table-column>

              <el-table-column
                label="商品名称"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">{{
                  scope.row.productName
                }}</template>
              </el-table-column>

              <el-table-column
                label="秒杀起始销量"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.initialSalesVolume"
                    placeholder="请输入"
                    type="number"
                    :style="{ width: '80%' }"
                    @input="handleInput($event, scope.$index, 1)"
                  ></el-input>
                </template>
              </el-table-column>

              <el-table-column
                label="是否限购"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <el-switch
                    v-model="scope.row.isLimit"
                    :active-value="1"
                    :inactive-value="0"
                    @change="changeIsLimit(scope.$index)"
                  >
                  </el-switch
                ></template>
              </el-table-column>

              <el-table-column
                label="限购数量"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.limitNum"
                    placeholder="请输入"
                    type="number"
                    :style="{ width: '80%' }"
                    :disabled="scope.row.isLimit === 0"
                    @input="handleInput($event, scope.$index, 2)"
                  ></el-input>
                </template>
              </el-table-column>

              <el-table-column
                prop="date"
                label="秒杀活动图"
                width="180"
                align="center"
              >
                <template slot-scope="scope">
                  <el-upload
                    class="avatar-uploader"
                    :action="$uploadURL"
                    :show-file-list="false"
                    :on-success="
                      function (res, file, fileList) {
                        return handleUploadSeckillImg(file, scope.$index);
                      }
                    "
                  >
                    <img
                      v-if="scope.row.seckillImg"
                      :src="scope.row.seckillImg"
                      class="avatarSmall"
                    />
                    <i v-else class="el-icon-upload small-uploader-icon"></i>
                  </el-upload>
                </template>
              </el-table-column>

              <el-table-column
                label="操作"
                width="290"
                align="center"
                v-if="!seckillProductCode"
              >
                <template slot-scope="scope">
                  <el-button type="text" @click="handleDelete(scope.$index)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-form-item>
      </el-form>

      <div class="btn-box">
        <el-button type="info" style="background-color: grey" @click="goBack()"
          >返回</el-button
        >
        <el-button type="primary" style="marginleft: 200px" @click="submit()"
          >提交</el-button
        >
      </div>
    </div>

    <el-dialog
      title="选择商品"
      center
      :visible.sync="dialogVisible"
      width="70%"
    >
      <div class="select-box">
        <div>
          <el-row :gutter="10">
            <el-col :span="7">
              <div class="item-col">
                <span class="label">商品名称 </span>
                <div>
                  <el-input
                    v-model="goodsSearch.condition.productName"
                    style="width: 100%"
                    placeholder="请输入"
                  ></el-input>
                </div></div
            ></el-col>
            <!-- <el-col :span="7">
              <div class="item-col">
                <span class="label">商品分类 </span>
                <div>
                  <el-select
                    v-model="value"
                    placeholder="请选择"
                    style="width: 100%;"
                  >
                    <el-option label="item.label" value="item.value">
                    </el-option>
                    <el-option label="item.label" value="item.value">
                    </el-option>
                  </el-select>
                </div></div
            ></el-col> -->

            <el-col :span="5"
              ><el-button
                type="primary"
                icon="el-icon-search"
                @click="searchGoods"
                >查询</el-button
              >
              <el-button type="info" icon="el-icon-refresh" @click="restGoods"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </div>
        <div style="height: 300px; overflow-y: auto">
          <el-table
            :data="goodsData.goodsList"
            height="100%"
            style="width: 100%"
            border
          >
            <el-table-column prop="productName" label="商品名称" align="center">
            </el-table-column>

            <el-table-column prop="name" label="商品图片" align="center">
              <template slot-scope="{ row }">
                <img
                  style="width: 50px; height: 50px"
                  :src="row.listImg"
                  alt=""
                />
              </template>
            </el-table-column>

            <el-table-column
              prop="categoryFirstName"
              label="一级分类"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="categorySecondName"
              label="二级分类"
              align="center"
            >
            </el-table-column>

            <el-table-column prop="address" label="商品状态" align="center">
              <template slot-scope="{ row }">
                <el-button v-if="row.productStatus == 1" type="success"
                  >进行中</el-button
                >
                <el-button v-if="row.productStatus == 2" type="danger"
                  >已下架</el-button
                >
              </template>
            </el-table-column>
            <el-table-column label="" width="100">
              <template slot-scope="{ row }">
                <el-button type="text" size="small" @click="selectGoods(row)"
                  >选择</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="display: flex; justify-content: flex-end">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="goodsData.count"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor'

export default {
  components: {
    quillEditor
  },

  data () {
    return {
      rangeTime: [],
      seckillProductCode: '',
      productCode: '',
      formData: {
        startTime: '',
        endTime: '',
        // tableData: [],
        productList: [
          {
            categoryFirstCode: '',
            categoryFirstName: '',
            categorySecondCode: '',
            categorySecondName: '',
            supplierCode: '',
            supplierName: '',
            productName: '',
            sellPoint: '',
            listImg: '',
            bannerImg: '',
            bigImg: '',
            reportImg: '',
            purchaseLimit: null,
            initialSalesVolume: null,
            // 商品规格数据
            productSkuList: []
          }
        ]
      },
      dialogVisible: false,
      goodsSearch: {
        condition: {
          productCode: '',
          productName: ''
        },
        count: 0,
        currPage: 1,
        pageCount: 0,
        pageSize: 10
      },
      goodsData: {
        count: 0,
        goodsList: []
      },
      height: window.innerHeight - 256 // 表格高度
    }
  },
  async created () {
    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.formData.creator = userInfo.userInfo.nickName
    this.seckillProductCode = this.$route.query.seckillProductCode
    if (this.seckillProductCode) {
      this.getSeckillProductInfo(this.seckillProductCode)
    } else {
      this.formData.productList = []
      await this.getAllGoods()
    }
  },
  methods: {
    handleCurrentChange (val) {
      this.goodsSearch.currPage = val
      this.getAllGoods()
    },
    handleInput (value, index, type) {
      if (isNaN(value) || value < 0) {
        if (type == 1) {
          this.formData.productList[index].initialSalesVolume = ''
        } else if (type == 2) {
          this.formData.productList[index].limitNum = ''
        }
        this.$message({
          message: '此项不能为负数！',
          type: 'fail'
        })
      }
    },
    handleSonInput (value, index, parentIndex, type) {
      if (isNaN(value) || value < 0) {
        if (type == 1) {
          this.formData.productList[parentIndex].productSkuList[index].seckillPrice = ''
        } else if (type == 2) {
          this.formData.productList[parentIndex].productSkuList[index].seckillStock = ''
        }
        this.$message({
          message: '此项不能为负数！',
          type: 'fail'
        })
      }
    },
    changeIsLimit (index) {
      this.formData.productList[index].limitNum = ''
    },
    async getSeckillProductInfo (val) {
      this.$http
        .post('/seckillProduct/queryDetail', {
          seckillProductCode: val
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.formData.productList = [res.data.data]
            this.formData.productList[0].productSkuList =
              res.data.data.seckillSkuList
            this.formData.startTime = res.data.data.startTime
            this.formData.endTime = res.data.data.endTime
            this.rangeTime = [this.formData.startTime, this.formData.endTime]
            console.log('312323', this.formData)
          }
        })
    },
    goBack () {
      this.$router.back()
    },
    changeTime (data) {
      if (data) {
        this.formData.startTime = data[0]
        this.formData.endTime = data[1]
      } else {
        this.rangeTime = []
        this.formData.startTime = ''
        this.formData.endTime = ''
      }
    },
    selectGoodDia () {
      this.dialogVisible = true
    },
    // 获取所有商品
    getAllGoods () {
      let _this = this
      this.$http
        .post('/product/listSku', {
          ..._this.goodsSearch
        })
        .then(function (res) {
          let { count, currPage, data, pageCount, pageSize } = res.data.data
          _this.goodsData.goodsList = data
          _this.goodsData.count = count
        })
    },
    searchGoods () {
      this.searchGoods.currPage = 1
      this.getAllGoods()
    },
    restGoods () {
      this.goodsSearch.condition.productCode = ''
      this.goodsSearch.condition.productName = ''
      this.goodsSearch.currPage = 1
      this.goodsData.pageCount = 0
      this.goodsData.pageSize = 10
      this.getAllGoods()
    },
    selectGoods (row) {
      row.initialSalesVolume = null
      row.isLimit = 0
      this.formData.productList.push(row)
      this.dialogVisible = false
    },
    // 秒杀活动图上传成功处理
    handleUploadSeckillImg (file, index) {
      this.formData.productList[index].seckillImg = file.response.data.url
      this.$forceUpdate() // 触发强制刷新
    },
    // 删除秒杀商品项
    handleDelete (index) {
      this.formData.productList.splice(index, 1)
    },
    // 删除秒杀商品规格项
    handleDeleteSku (index1, index2) {
      this.formData.productList[index2].productSkuList.splice(index1, 1)
    },
    async submit () {
      let _this = this
      if (this.seckillProductCode) {
        // 编辑提交
        _this.formData.productList[0].seckillSkuList = _this.formData.productList[0].productSkuList
        _this.formData.productList[0].startTime = _this.formData.startTime
        _this.formData.productList[0].endTime = _this.formData.endTime
        this.$http
          .post('/seckillProduct/edit', {
            ..._this.formData.productList[0]
          })
          .then(function (res) {
            console.log(res)
            if (res.data.code == 200) {
              _this.$message({
                message: '保存成功!',
                type: 'success'
              })
              _this.$router.back()
            } else {
              _this.$message({
                message: res.data.message,
                type: 'fail'
              })
            }
          })
      } else {
        // 新增提交
        this.$http
          .post('/seckill/save', {
            ..._this.formData
          })
          .then(function (res) {
            console.log(res)
            if (res.data.code == 200) {
              _this.$message({
                message: '保存成功!',
                type: 'success'
              })
              _this.$router.back()
            } else {
              _this.$message({
                message: res.data.message,
                type: 'fail'
              })
            }
          })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.children-box {
  .nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
  }

  .procedure {
    width: 90%;
  }

  .title {
    background-color: #f1f1f1;
  }
}

.select-box {
  .item-col {
    display: flex;
    align-items: center;
    margin-bottom: 18px;

    .label {
      margin-right: 10px;
    }

    div {
      flex: 1;
    }
  }
}

.item-num {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.active-color {
  background-color: #1e98d7;
  color: #fff;
}

.size {
  display: flex;
  align-items: center;
  justify-content: center;
}

.unactive-color {
  border: 0.5px solid #adadad;
  border-color: #adadad;
}

.item-text {
  margin: 0 10px;
}

.line {
  width: 80px;
  height: 0.5px;
  border-top: 1px solid #adadad;
  margin: 0 10px;
}

.last-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 40px;
  margin-top: 50px;
  margin-left: 50px;
  border: 1px solid #adadad;
  border-radius: 10px;
  color: #333;
  cursor: pointer;
}

.next-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 40px;
  margin-top: 50px;
  margin-left: 70px;
  background-color: #1e98d7;
  border-radius: 10px;
  color: #fff;
  cursor: pointer;
}

.btn-box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
  padding-bottom: 20px;

  div {
    transform: translateX(-60%);
  }
}

/deep/ .el-form {
  margin-top: 10px;
  margin-left: 30px;

  .el-input {
    width: 300px;
  }

  .el-input-number {
    .el-input__inner {
      width: 100px;
    }
  }
}

.avatar {
  width: 146px;
  height: 146px;
  display: block;
}

.avatarSmall {
  width: 60px;
  height: 60px;
  display: block;
}

.avatar-uploader .el-upload {
  cursor: pointer;
  position: relative;
  overflow: hidden;
  align-items: center;
}

.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 146px;
  height: 146px;
  line-height: 146px;
  text-align: center;
}

.small-uploader-icon {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}

.spec-row {
  display: flex;
  justify-content: center;
  align-items: center;
}

.spec-item {
  margin-right: 30px;
  flex: 1;
}

.spec-item input {
  width: 100%;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: white;
}

button {
  padding: 5px 10px;
  border: none;
  background-color: #007bff;
  color: white;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background-color: #0056b3;
}
</style>
